export const IS_PRODUCTION = !!process.env.REACT_APP_API_URL
export const TOAST_ANIMATION_DURATION = 400
